export default __webpack_public_path__ + "static/Charles_Bridge_Prague_Czech_Republic-d0e53d2da10844bff2bd68c22c175efd.jpg";